import { ConnectProviderWarningModal } from './ConnectProviderWarningModal';

export default ConnectProviderWarningModal;
